var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('index'),(_vm.showButton)?_c('div',{staticClass:"scrollsidebar",staticStyle:{"display":"block"}},[_c('img',{attrs:{"src":require("./assets/top.png")},on:{"click":_vm.scrollToTop}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }